"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Exception thrown when an illegal index was requested. This represents errors that should be detected at compile time.
 */
const Exception_1 = __importDefault(require("./Exception"));
class OutOfRangeException extends Exception_1.default {
}
exports.default = OutOfRangeException;
//# sourceMappingURL=OutOfRangeException.js.map